import { createFileRoute, Outlet } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { z } from 'zod';

import { CustomerLocationsHeader } from '@/components/customer-locations-header';
import { SubmenuNavigation } from '@/components/submenu-navigation';

export const Route = createFileRoute('/_auth/customer/locations/_modules')({
    component: RouteComponent,
    validateSearch: z.object({
        search: z.string().optional(),
    }),
});

function RouteComponent() {
    const { t } = useTranslation('customer-locations');
    const search = Route.useSearch();

    return (
        <>
            <div className="max-w-screen-2xl flex flex-col flex-1 px-4 pt-4 sm:px-8 sm:pt-8 pb-0 overflow-y-auto h-full">
                <CustomerLocationsHeader route={Route} />
                <SubmenuNavigation
                    items={[
                        {
                            label: t('locations.modules.electrical.name'),
                            to: '/customer/locations/electrical',
                            search: { search: search.search || undefined },
                        },
                        {
                            label: t('locations.modules.cooling.name'),
                            // to: '/customer/locations/cooling',
                            search: { search: search.search || undefined },
                            disabled: true,
                        },
                        {
                            label: t('locations.modules.atex.name'),
                            // to: '/customer/locations/atex',
                            search: { search: search.search || undefined },
                            disabled: true,
                        },
                        {
                            label: t('locations.modules.water.name'),
                            // to: '/customer/locations/water',
                            search: { search: search.search || undefined },
                            disabled: true,
                        },
                        {
                            label: t('locations.modules.legionella.name'),
                            // to: '/customer/locations/legionella',
                            search: { search: search.search || undefined },
                            disabled: true,
                        },
                        {
                            label: t('locations.modules.solar.name'),
                            // to: '/customer/locations/solar',
                            search: { search: search.search || undefined },
                            disabled: true,
                        },
                        {
                            label: t('locations.modules.air.name'),
                            // to: '/customer/locations/air',
                            search: { search: search.search || undefined },
                            disabled: true,
                        },
                    ]}
                />
                <Outlet />
            </div>
        </>
    );
}
